<template>
  <div id="returnMaterManage">
        
        <el-col class="searthPart">
            <el-form ref="searchForm" :inline="true" :model="searchForm" :label-position="labelPosition">
                <el-form-item  class="hewidth">
                    <el-input clearable v-model.trim="searchForm.returnNumber" placeholder="请输入退料编码" maxlength="50" ></el-input>
                </el-form-item>
                <el-form-item  class="hewidth">
                    <el-input clearable v-model.trim="searchForm.inventoryCode" placeholder="序列号" maxlength="50" ></el-input>
                </el-form-item>
                <el-form-item class="hewidth">
                        <el-input clearable v-model.trim="searchForm.orderNo" placeholder="对应服务单号" maxlength="50"></el-input>
                    </el-form-item>
                <el-form-item  class="hewidth">
                    <el-select clearable filterable v-model.trim="searchForm.belonger" @change="changeBelonger" :filter-method="PinyinMatch" placeholder="退料人">
                        <el-option v-for="item,index in returnPersonList"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item class="hewidth">
                    <el-select filterable v-model.trim="searchForm.createUser" @change="changeCreateUser" :filter-method="PinyinMatch1" placeholder="收料人" clearable>
                        <el-option v-for="(item,index) in reciverList"
                            :label="item.staffName"
                            :value="item.userId"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                    <el-form-item class="hewidth">
                        <el-select filterable v-model="searchForm.residualType" placeholder="残值类型" clearable>
                            <el-option v-for="(item,index) in residualList"
                                :label="item.paraName"
                                :value="item.paraValue"
                                :key="index">
                            </el-option>
                        </el-select>
                    
                </el-form-item>
                <el-form-item class="hewidth">
                        <el-select filterable v-model="searchForm.returnType" placeholder="退料类型" clearable>
                            <el-option v-for="(item,index) in returnList"
                                :label="item.paraName"
                                :value="item.paraValue"
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                <div class="clearfix">
                    <el-form-item class="hewidth">
                        <el-select filterable v-model="searchForm.status" placeholder="状态" clearable>
                            <el-option v-for="(item,index) in statusList"
                                :label="item.paraName"
                                :value="item.paraValue"
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item class="hewidth">
                        <el-select filterable v-model="searchForm.isRetenRetain" placeholder="是否自留" clearable>
                            <el-option v-for="(item,index) in isRetenRetainList"
                                :label="item.paraName"
                                :value="item.paraValue"
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width:34%">
                        <el-date-picker
                            v-model="valueTime3"
                            type="daterange"
                            range-separator="-"
                            :default-time="['00:00:00', '23:59:59']"
                            start-placeholder="退料开始"
                            end-placeholder="退料开始">
                        </el-date-picker>
                    </el-form-item>
                    
                    
                    <el-form-item style="width:30%">
                    <el-button type="primary" size="medium" @click="onSubmit('searchForm')" style="width:80px;">查询</el-button>
                    <el-button type="text" @click="clearForm()" style="width: 60px;color: #169BD5;">重置</el-button>
                    <!-- <el-row class="clearfix" style="position: absolute;right:40px;top:16px;"> -->
            <!-- <el-button type="success" size="medium" v-if="basicsAuth.returnMaterialAdd" @click="createOrder()">新建退料</el-button> -->
            <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')" >导出</el-button>
            <!-- <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 10px" @click="refresh()"></i> -->
        </el-row>
    </el-form-item>
                </div>
            </el-form>
        </el-col>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    id="tableId"
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        prop="shopName"
                        width="110"
                        label="网点名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="engineerName"
                        label="退料人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUser"
                        label="收料人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="modelName"
                        width="150"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialCode"
                        width="100"
                        label="物料编码">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        width="250"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="inventoryCode"
                        width="100"
                        label="序列号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="code"
                        label="数量">
                        <template slot-scope="scope">
                            <span>1</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 'YQR'">已确认</span>
                            <span v-if="scope.row.status == 'save'">暂存</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="orderNo"
                        width="180"
                        label="对应服务单号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        width="155"
                        label="退料日期">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="residualType"
                        width="100"
                        label="残值类型">
                        <template slot-scope="scope">
                            {{ scope.row.residualType | sysCodeFileter('residual_type')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="residualValue"
                        label="残值价格">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="100"
                        prop="isRetenRetain"
                        label="是否保留">
                        <template slot-scope="scope">
                            {{ scope.row.isRetenRetain | sysCodeFileter('is_reten_retain')}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100,1000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    import PinyinMatch from 'pinyin-match';
    let moment = require("moment");
    import {
        returnMaterialDetailsList,
        returnMaterialType,
        engineerList,
        queryUserList,
        selectParameterInfoBusiness
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'returnMaterManage',
        components: {
        },
        data () {
            return {
                valueTime3:[],
                pickingTypeList:[   //退料类型
                    {
                        paraName:'普通退料',
                        paraCode:1
                    },
                    {
                        paraName:'残值退料',
                        paraCode:2
                    }
                ],
                statusList:[
                    {
                        paraName:'已确认',
                        paraValue:'YQR'
                    },
                    {
                        paraName:'暂存',
                        paraValue:'save'
                    }
                ],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                isRetenRetainList:[],
                labelPosition:'left',
                searchForm:{
                    orderNo:'',
                    createUser:'',
                    belonger:'',
                    returnNumber:'',
                    inventoryCode:'',
                    returnType:'',
                    residualType:'',
                    createTimeFrom:'',
                    createTimeTo:'',
                    isRetenRetain:'',
                    status:''
                },
                returnData: [],
                copy:[],
                copy1:[],
                returnPersonList:[],  //退料人
                reciverList:[],       //收料人
                residualList:[],      //残值类型
                returnList:[],        //退料类型
                basicsAuth:{
                    returnMaterialAdd:false
                }
            }
        },
        mounted(){
            this.basicsAuth.returnMaterialAdd = getPermission("/api/returnMaterial/returnMaterialAdd")
        },
        created(){
            this.getReturnPersonList();
            this.getReciverList();
            this.getResidualList(); //残值类型
            this.getReturnList();
            this.returnMaterialDetailsList();
            this.getIsRetenRetainList();
        },
        methods: {
            //强制刷新
            changeBelonger(e){
                this.searchForm.belonger = e;
                this.$forceUpdate();
            },
            changeCreateUser(e){
                this.searchForm.createUser = e;
                this.$forceUpdate();
            },
            //退料人拼音模糊搜索
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.belonger = val;
                    this.returnPersonList = result;
                }else{
                    this.returnPersonList = this.copy;
                    this.searchForm.belonger = "";
                }
            },
            //领料人拼音模糊搜索
            PinyinMatch1(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy1.forEach(i => {
                        let m = PinyinMatch.match(i.staffName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.createUser = val;
                    this.reciverList = result;
                }else{
                    this.reciverList = this.copy1;
                    this.searchForm.createUser = "";
                }
            },
            //获取是否自留列表
            getIsRetenRetainList(){
                let params = {
                    paraType:'is_reten_retain'
                }
                selectParameterInfoBusiness(params).then(res => {
                    if (res.data.status==100) {
                        this.isRetenRetainList = res.data.results.list;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取收料人列表
            getReciverList(){
                queryUserList({startRow:1,pageSize:1000}).then(res => {
                    if (res.data.status==100) {
                        this.reciverList = res.data.results.list;
                        this.copy1 = Object.assign(this.reciverList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取退料人列表
            getReturnPersonList(){
                let params = {
                    startRow:1,
                    pageSize:10000,
                }
                engineerList(params).then(res => {
                    if (res.data.status==100) {
                        this.returnPersonList = res.data.results.list;
                        this.copy = Object.assign(this.returnPersonList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取残值类型列表
            getResidualList(){
                let params = {
                    paraType:'residual_type'
                }
                selectParameterInfoBusiness(params).then(res => {
                    if (res.data.status==100) {
                        this.residualList = res.data.results.list;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取退料类型列表
            getReturnList(){
                let params = {
                    paraType:'sales_return_type'
                }
                selectParameterInfoBusiness(params).then(res => {
                    if (res.data.status==100) {
                        this.returnList = res.data.results.list;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            clearForm(){
                this.searchForm = {}
                this.valueTime3 = []
                this.onSubmit('searchForm');
            },
            //获取采购管理列表
            returnMaterialDetailsList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                returnMaterialDetailsList(this.searchForm).then(res => {
                    if (res.data.status==100) {
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.createTime = this.filters.formatDate(item.createTime)
                            })
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.returnMaterialDetailsList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.returnMaterialDetailsList()
            },
            //进入详情页面
            //备用 goToDetail
            goToDetail(row) {
                this.$router.push({
                    path:'/returnMaterInfo',
                    query:{
                      orderId:row.id
                    }
                })
            },
            //新建退料
            createOrder() {
                this.$router.push({
                    path:'/newReturnMater'
                })
            },
            refresh() {
                this.searchForm = {}
                this.returnMaterialDetailsList();
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime3 == null){
                            this.searchForm.createTimeFrom = "";
                            this.searchForm.createTimeTo = "";
                        }else if(this.valueTime3.length == 0){
                            this.searchForm.createTimeFrom = "";
                            this.searchForm.createTimeTo = "";
                        }else{
                            this.searchForm.createTimeFrom = new Date(this.valueTime3[0])
                            this.searchForm.createTimeTo = new Date(this.valueTime3[1])
                        }
                        this.returnMaterialDetailsList()

                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #returnMaterManage{
        font-size: 14px;
        .el-form-item{
            margin-bottom:15px
        }
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px;
        }
    }
.hewidth {
        width: 15% !important;
      }
</style>



// WEBPACK FOOTER //
// returnMaterManage.vue?32e788f4